/**
 * @packageDocumentation
 * @module f1/string
 */

export interface SearchValue {
  /**
   * Returns the search string if found, otherwise an empty string
   *
   * @public
   * @function f1.searchValue
   * @param search the string to search for
   * @param from the index to start looking
   * @param s a string of a variable
   * @example
   *
   * ```ts
   * f1.searchValue('a', 2, 'abca') === 'a'
   * f1.searchValue('a', 2, 'abcd') === ''
   * ```
   */
  (search: string, from: number, s: string): string;
  (search: string, from: number): (s: string) => string;
}

/**
 * @see SearchValue
 */
export default (search: string, start: number, s: string) => {
  return s.includes(search, start) ? search : '';
};
